<template>
    <el-dialog title="提现申请" :visible.sync="formVisible" :close-on-click-modal="false">
        <div class="divEWM" v-show="istips">你的收入已经被评估为专家，不再支持二维码提现，此后将以转账的形式提现<br /><span>如有疑问请关注公众号联系客服</span></div>
        <el-col :span="24" style="margin-bottom: 20px;">
            <el-form :model="formData" label-width="80px" :rules="formRules" ref="formd">
                <el-form-item label="方式" v-show="showFs">
                    <el-radio-group v-model="formData.infos.fs" size="small">
                        <el-radio-button label="geren">个人</el-radio-button>
                        <el-radio-button label="qiye">企业</el-radio-button>
                        <el-radio-button label="ali">支付宝</el-radio-button>
                        <!-- <el-radio-button label="geti">个体工商</el-radio-button> -->
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="金额" prop="amt">
                    <el-input v-model="formData.amt" auto-complete="off"></el-input>
                </el-form-item>
                <div v-show="formData.infos.fs == 'geren'">
                    <el-form-item label="姓名" prop="idname">
                        <el-input v-model="formData.infos.idname" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="身份号" prop="idcard">
                        <el-input v-model="formData.infos.idcard" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="银行卡" prop="banknum">
                        <el-input v-model="formData.infos.banknum" placeholder="姓名、地址必须和银行帐户能对上，否则可能转账失败"
                            auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行" prop="bankaddr">
                        <el-input v-model="formData.infos.bankaddr" placeholder="开户行地址" auto-complete="off"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="扣税">
                        <el-radio-group v-model="formData.kstypes" size="small">
                            <el-radio-button label="daikou">代扣代缴</el-radio-button>
                            <el-radio-button label="kaipiao">自己开票</el-radio-button>
                            <el-radio-button label="geti">个体工商</el-radio-button>
                        </el-radio-group>
                        <el-link type="info" :underline="false" style="margin-left:30px;">什么意思？</el-link>
                    </el-form-item>
                    <div v-show="formData.kstypes == 'kaipiao'">
                        <el-form-item label="电子发票" prop="name">
                            <label>请上传PDF文件
                                <input type="file" accept="application/pdf" @change="changeImg($event)">
                            </label>
                        </el-form-item>
                        <el-form-item label="完税证明" prop="name">
                            <label>请上传PDF文件
                                <input type="file" accept="application/pdf" @change="changeImg($event)">
                            </label>
                        </el-form-item>
                    </div> -->
                </div>
                <div v-show="formData.infos.fs == 'qiye'">
                    <el-form-item label="企业名称" prop="qyname">
                        <el-input v-model="formData.infos.qyname" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="统一信用码" label-width="100px" prop="qynum">
                        <el-input v-model="formData.infos.qynum" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="银行帐户" prop="banknum">
                        <el-input v-model="formData.infos.banknum" placeholder="名称、地址必须和银行帐户能对上，否则可能转账失败"
                            auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行" prop="bankaddr">
                        <el-input v-model="formData.infos.bankaddr" placeholder="开户行地址" auto-complete="off"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="电子发票" prop="name">
                        <label>请上传PDF文件
                            <input type="file" accept="application/pdf" @change="changeImg($event)">
                        </label>
                    </el-form-item> -->
                </div>
                <div v-show="formData.infos.fs == 'ali'">
                    <el-form-item label="支付宝" prop="aliid">
                        <el-input v-model="formData.infos.aliid" auto-complete="off"></el-input>
                        <div>
                            <el-tag type="info" size="mini">请到支付宝个人中心查看准确的登录账号（一般是手机号或邮箱）</el-tag>
                        </div>
                    </el-form-item>
                    <el-form-item label="姓名" prop="aliname">
                        <el-input v-model="formData.infos.aliname" auto-complete="off"></el-input>
                        <div>
                            <el-tag type="info" size="mini">请务必填写支付宝账号对应的实名认证真实姓名</el-tag>
                        </div>
                    </el-form-item>
                </div>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="formData.desc" auto-complete="off"></el-input>
                </el-form-item>
                <div class="divXFTX">
                    <span>友情提醒：根据《中华人民共和国宪法》第56条明确规定，依法纳税是每个公民的基本义务。
                        本平台对作者的收益没有代扣代缴义务，请作者在平台上获得相应的收益后，自行完成纳税义务，
                        如有疑问，可咨询当地12366纳税服务热线处理，特此告知!
                    </span>
                </div>
            </el-form>
        </el-col>
        <!--工具条-->
        <div slot="footer" class="dialog-footer">
            <el-tag type="warning" style="float: left;">提现需要收取10%服务费</el-tag>
            <el-button @click.native="formVisible = false">取消</el-button>
            <el-button type="primary" @click.native="formSubmit" :loading="formLoading">确认</el-button>
        </div>
    </el-dialog>
</template>


<script>
var regAmt = /^\d+(\.\d+)?$/;
export default {
    data() {
        return {
            formVisible: false,
            formLoading: false,
            formRules: {
                amt: [
                    { required: true, message: '请输入金额' },
                    {
                        validator: (rule, value, callback) => {
                            try {
                                if (value == '') {
                                    callback(new Error('请输入金额!'));
                                } else if (regAmt.test(value)) {
                                    let amt = parseFloat(value);
                                    if (amt < 100)
                                        callback(new Error('最少提100元'));
                                    else if (amt > 50000)
                                        callback(new Error('最多提50000元'));
                                    else
                                        callback();
                                } else
                                    callback(new Error('格式错误：必须是 "数字"'));
                            } catch (e) {
                                callback(new Error('格式错误!:必须是 "金额"'));
                            }
                        }
                    }
                ]
            },
            //新增界面数据
            formData: { infos: {} },

            istips: false,
            showFs: false,
        }
    },
    mounted() {
    },
    methods: {
        show() {
            this.formVisible = true;
            this.formLoading = false;
            this.formData = {
                xid: '',
                amt: '',
                desc: '',
                imgid: '',
                imgs: '',
                infos: {
                    fs: 'geren',
                    idname: '',
                    idcard: '',
                    qyname: '',
                    qynum: '',
                    banknum: '',
                    bankaddr: '',
                    aliid: '',
                    aliname: '',
                }
            }
            this.getLastInfos();
        },
        /*handleSelect:function(id){
                        this.tmpltCont='';
                        if(id==''){
                            return
                        }
                        let it=this.tmplatdatas[id];
                        if(it==null){
                            return
                        }
                        //console.log("123",this.tmplatdatas[id]);
                        this.tmpltCont=it.Content;
                        this.tmpltmapls=[];
                        SmsTmpltKeys(id).then(res=>{
                            for(let i in res.data){
                                this.tmpltmapls.push({
                                    key:res.data[i],value:''
                                });
                            }
                        });
                    },*/
        formSubmit() {
            this.$refs.formd.validate((valid) => {
                if (valid) {
                    /* let regd = /^(data:application\/pdf).+/;
                    if (this.formData.infos.fs == 'qiye' && !regd.test(this.formData.imgs)) {
                        this.$message({
                            message: '请上传电子发票文件',
                            type: 'error'
                        });
                        return;
                    } */
                    if (this.formData.infos.fs == 'geren') {
                        if (this.formData.infos.idname == "" || this.formData.infos.idcard == "") {
                            this.$message({
                                message: '请填写个人信息',
                                type: 'error'
                            });
                            return;
                        }
                        if (this.formData.infos.idcard.length < 18 || this.formData.infos.idcard.length > 20) {
                            this.$message({
                                message: '身份证有误',
                                type: 'error'
                            });
                            return;
                        }
                        if (this.formData.infos.banknum == '' || this.formData.infos.bankaddr == '') {
                            this.$message({
                                message: '请填写银行信息',
                                type: 'error'
                            });
                            return;
                        }
                    } else if (this.formData.infos.fs == 'qiye') {
                        if (this.formData.infos.qyname == "" || this.formData.infos.qynum == "") {
                            this.$message({
                                message: '请填写企业信息',
                                type: 'error'
                            });
                            return;
                        }
                        if (this.formData.infos.qynum.length < 18 || this.formData.infos.qynum.length > 20) {
                            this.$message({
                                message: '统一信用码有误',
                                type: 'error'
                            });
                            return;
                        }
                        if (this.formData.infos.banknum == '' || this.formData.infos.bankaddr == '') {
                            this.$message({
                                message: '请填写银行信息',
                                type: 'error'
                            });
                            return;
                        }
                    } else {
                        if (this.formData.infos.aliid == "" || this.formData.infos.aliname == "") {
                            this.$message({
                                message: '请填写支付宝信息',
                                type: 'error'
                            });
                            return;
                        }
                    }
                    this.formLoading = true;
                    this.$post('/user/tx-tax', this.formData).then(res => {
                        console.log(res);
                        this.$emit('submitOK');
                        this.formLoading = false;
                        this.formVisible = false;
                        //this.$message('操作成功');
                    }).catch(err => {
                        this.$emit('submitErr', err);
                        this.formLoading = false;
                        //this.formVisible = false;
                        this.$message({
                            message: err.response ? err.response.data || '服务器错误' : '网络错误',
                            type: 'error'
                        });
                    });
                }
            });
        },
        changeImg(e) {
            let file = e.target.files[0]
            if (file.size > 2 * 1024 * 1024) {
                this.$message({
                    message: '【' + (file.name.length > 20 ? file.name.substring(0, 20) + '...' : file.name) + '】 超过2M',
                    type: 'error'
                });
                return;
            }
            let that = this
            let reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = function (e) {
                that.formData.imgid = '';
                that.formData.imgs = this.result;
                // console.log('imgs',that.formData.imgs)
            }
        },
        getLastInfos() {
            this.formLoading = true;
            this.$post('/user/tx-taxs').then(res => {
                this.formLoading = false;
                if (res.data.infos && res.data.infos.fs && res.data.infos.fs != '')
                    this.formData.infos = res.data.infos;
                if (res.data.txstat == 1) {
                    this.showFs = true; this.istips = true;
                }
                if (res.data.txstat == 5) {
                    this.showFs = false;
                    this.istips = true;
                    this.formData.infos.fs = 'ali';
                }
                this.$forceUpdate();
            }).catch(err => {
                this.formLoading = false;
                /*this.$message({
                    message: err.response ? err.response.data || '服务器错误' : '网络错误',
                    type: 'error'
                });*/
            });
        }
    }
};
</script>

<style scoped>
.tmpdesc {
    margin-left: 10px;
    color: #d0d0d0;
}

.img {
    width: 250px;
    height: 350px;
}

.divEWM {
    margin-bottom: 20px;
    text-align: center;
    font-size: 12px;
    color: #f30;

    span {
        color: #aaa;
    }
}

.divXFTX {
    padding-left: 20px;
    font-size: 12px;
    color: #aaa;
}
</style>



// WEBPACK FOOTER //
// txTaxEdit.vue?0d6d4208